<template>
  <StepLayout buttonDataEc="">
    <template slot="icon">
      <SpinLoader
        class="mr-sm transition-opacity ease-in-out delay-200 duration-150"
        :class="!mounted ? 'opacity-0' : 'opacity-100'"
        size="small"
      />
    </template>

    <template slot="title">
      <div
        class="transition-opacity ease-in-out delay-200 duration-150"
        :class="!mounted ? 'opacity-0' : 'opacity-100'"
      >
        <slot name="title" />
      </div>
    </template>

    <slot name="default">
      <div
        class="transition-opacity ease-in-out delay-200 duration-150"
        :class="!mounted ? 'opacity-0' : 'opacity-100'"
      >
        <TextSkeleton
          :pulse="true"
          class="block w-full h-thirtySix mb-base"
        />
        <TextSkeleton
          :pulse="true"
          class="block w-full h-thirtySix"
        />
      </div>
    </slot>
  </StepLayout>
</template>

<script setup>
import { onActivated, onDeactivated, ref } from 'vue';

import StepLayout from '@/components/layouts/StepLayout';
import SpinLoader from '@/components/library/loaders/SpinLoader.vue';
import TextSkeleton from '@/components/library/skeletons/TextSkeleton.vue';

const mounted = ref(false);
onActivated(() => {
  // delay changing class to allow the opacity transition to work
  window.requestAnimationFrame(() => {
    mounted.value = true;
  });
});
onDeactivated(() => {
  mounted.value = false;
});
</script>
